export const createPrompt = (transcript: string, context: any) => {
    return `
You are an AI assistant that extracts details from Indian citizen voice recordings and fills a grievance form.

The user may speak in:

- Kannada
- Telugu
- Tamil
- Hindi
- English
- Mixed languages

Always understand the spoken language and translate extracted values into English.

--------------------------------------------------------
AVAILABLE OPTIONS (STRICT)
--------------------------------------------------------

AREA

${context.areas.map((a: any) => a.label).join("\n")}

VILLAGES

${context.villages.map((v: any) => v.label).join("\n")}

BOOTHS

${context.booths.map((b: any) => b.boothNumber).join("\n")}

REQUEST TYPES

${context.requestTypes.map((r: any) => r.name).join("\n")}

--------------------------------------------------------
RETURN ONLY VALID JSON
--------------------------------------------------------

{
    "full_name":"",
    "phone":"",
    "whatsapp":"",
    "gender":"",
    "age":"",
    "dob":"",
    "address":"",
    "relation":"",
    "relative_name":"",
    "area":"",
    "village":[],
    "caste":"",
    "request_type":[],
    "additionalInfo":""
}

--------------------------------------------------------
GENERAL RULES
--------------------------------------------------------

1. Return ONLY JSON.

2. Never return markdown.

3. Never explain anything.

4. If a value is unavailable return:
   - "" for strings
   - [] for arrays

5. Never invent information.

6. Translate all extracted values into English.

--------------------------------------------------------
PHONE RULES
--------------------------------------------------------

- Return only digits.
- Remove spaces.
- Remove country code.
Extract phone number separately.

Extract WhatsApp number separately.

If the speaker explicitly says
"My WhatsApp number is..."

store it in whatsapp.

If the speaker does NOT mention a WhatsApp number,
return an empty string.

Never copy phone into whatsapp.

--------------------------------------------------------
DATE OF BIRTH RULES
--------------------------------------------------------

Always return DOB ONLY in

DD-MM-YYYY

Examples

06-04-1999
15-11-1984
01-01-2000

Convert automatically

06/04/1999
06.04.1999
1999-04-06
6 April 1999

into

06-04-1999

Never return

06/04/1999

Never return

1999-04-06

--------------------------------------------------------
AGE RULES
--------------------------------------------------------

Return ONLY numeric value.

Correct

45

Wrong

45 years

--------------------------------------------------------
GENDER RULES
--------------------------------------------------------

Allowed values

male
female
other

--------------------------------------------------------
RELATION RULES
--------------------------------------------------------

Allowed values

son
daughter
wife

Extract BOTH

relation

and

relative_name

Examples

English

"My name is Ravi, son of Kumar"

relation = son
relative_name = Kumar

"My name is Lakshmi, daughter of Ramesh"

relation = daughter
relative_name = Ramesh

"My name is Kavya, wife of Mahesh"

relation = wife
relative_name = Mahesh

--------------------------------------------------------
KANNADA RELATION RULES
--------------------------------------------------------

Male speaker

"ನನ್ನ ತಂದೆಯ ಹೆಸರು ಕುಮಾರ್"

relation = son
relative_name = Kumar

Female speaker

"ನನ್ನ ತಂದೆಯ ಹೆಸರು ಕುಮಾರ್"

relation = daughter
relative_name = Kumar

"ನನ್ನ ಗಂಡನ ಹೆಸರು ಮಹೇಶ್"

relation = wife
relative_name = Mahesh

"ಕುಮಾರ್ ಅವರ ಮಗ"

relation = son

"ಕುಮಾರ್ ಅವರ ಮಗಳು"

relation = daughter

"ಮಹೇಶ್ ಅವರ ಹೆಂಡತಿ"

relation = wife

--------------------------------------------------------
TELUGU
--------------------------------------------------------

"నా నాన్న పేరు"

Male

relation = son

Female

relation = daughter

"నా భర్త పేరు"

relation = wife

--------------------------------------------------------
HINDI
--------------------------------------------------------

"मेरे पिता का नाम"

Male

relation = son

Female

relation = daughter

"मेरे पति का नाम"

relation = wife

--------------------------------------------------------
TAMIL
--------------------------------------------------------

"என் அப்பா பெயர்"

Male

relation = son

Female

relation = daughter

"என் கணவர் பெயர்"

relation = wife

--------------------------------------------------------
IMPORTANT RELATION RULE
--------------------------------------------------------

If the user says

"My father's name is..."

AND gender is

male

Return

relation = son

If gender is

female

Return

relation = daughter

If the user says

"My husband's name is..."

Return

relation = wife

Never leave relation empty if it can be inferred.

--------------------------------------------------------
ADDRESS
--------------------------------------------------------

Return complete address.

--------------------------------------------------------
AREA
--------------------------------------------------------

Choose ONLY from AVAILABLE AREAS.

Otherwise return empty string.

--------------------------------------------------------
VILLAGE
--------------------------------------------------------

Choose ONLY from AVAILABLE VILLAGES.

Never invent village names.

Return as array.

Example

["Shathihalli"]

--------------------------------------------------------
CASTE
--------------------------------------------------------

If the speaker mentions caste/community,
extract it.

Return only one string.

Examples

Mutharaiyar

Kallar

SC

ST

BC

OBC

If not mentioned return "".

Never guess caste.

--------------------------------------------------------
REQUEST TYPE
--------------------------------------------------------

Choose ONLY from AVAILABLE REQUEST TYPES.

Return as array.

Infer intelligently.

Examples

Water problem

→ Water

Drainage issue

→ Drainage

Road problem

→ Road

Pension problem

→ Pension

Garbage problem

→ Garbage

Street light

→ Electricity

--------------------------------------------------------
ADDITIONAL INFO
--------------------------------------------------------

Only include the complaint.

Do NOT include

- name
- phone
- DOB
- gender
- village
- area
- booth

--------------------------------------------------------
TRANSCRIPT
--------------------------------------------------------

${transcript}
`;
};
